import { Calendar } from "lucide-react";

export default function BundesligaCard({data}) {
  return (
    <div className="mb-8">
      <div className="overflow-hidden rounded-2xl border border-gray-200/50 dark:border-gray-700/50 bg-white/80 dark:bg-gray-900/80 backdrop-blur shadow-lg text-gray-900 dark:text-white">

        <div className="p-6">
          <div className="flex flex-col md:flex-row items-center gap-6">

            {/* Logo */}
            <div className="w-24 h-24 rounded-2xl p-3 border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex items-center justify-center shrink-0">
              <img
                src={data?.league_logo}
                alt={data?.league_name}
                className="w-full h-full object-contain"
              />
            </div>

            {/* Main Content */}
            <div className="flex-1 text-center md:text-left">

              <h1 className="text-3xl font-bold mb-2 bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
                {data?.league_name}
              </h1>

              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 mb-3">

                {/* Sport Badge */}
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200">
                  ⚽ Football
                </span>

                {/* Season Badge */}
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 text-xs font-medium">

                  <Calendar className="w-3 h-3" />
                  {data?.league_year}
                </span>

              </div>

              {/* <p className="text-sm text-gray-500 dark:text-gray-400">
                📅 Aug 22, 2025 - May 16, 2026
              </p> */}
            </div>

            {/* Stats */}
            <div className="flex flex-wrap justify-center gap-6 w-full md:w-auto">

              <div className="text-center min-w-[80px]">
                <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                  {data?.totalMatches}
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  Total Matches
                </div>
              </div>

              <div className="text-center min-w-[80px]">
                <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                  {data?.totalTeams}
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  Total Teams
                </div>
              </div>

              <div className="text-center min-w-[80px]">
                <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                  {data?.totalVenues}
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  Venues
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
}